import React, { useState } from "react"
import propTypes from "prop-types"

import Label from "../Label"
import ErrorMessage from "../ErrorMessage"

const Password = ({ field, onChange, isSubmitted, children }) => {
  const [isHidden, setIsHidden] = useState(true)

  const togglePassword = e => {
    e.preventDefault()

    setIsHidden(!isHidden)
  }

  return (
    <div className="form_password">
      {field.label && <Label label={field.label} htmlFor={field.name} />}

      <input
        id={field.name}
        placeholder={field.placeholder}
        type={isHidden ? field.type : "text"}
        name={field.name}
        value={field.value}
        onChange={e => onChange(field.name, "value", e.target.value)}
        className={`form_element ${field.class} ${
          isSubmitted && !!field.message && field.required ? " is-invalid" : ""
        }`}
      />

      <div className="row">
        <div className="col">
          <ErrorMessage message={field.message} />
          {children}
        </div>
        <div className="col form_password_toggle-btn">
          <a
            onClick={togglePassword}
            href="/#"
            className="form_link form_link--small text-right"
          >
            <span className="form_password_toggle-btn--desktop">
              {isHidden ? "Show password" : "Hide password"}
            </span>
            <span className="form_password_toggle-btn--mobile">
              {isHidden ? "Show" : "Hide"}
            </span>
          </a>
        </div>
      </div>
    </div>
  )
}

Password.propTypes = {
  field: propTypes.shape({
    label: propTypes.string,
    placeholder: propTypes.string,
    name: propTypes.string.isRequired,
    type: propTypes.string.isRequired,
    value: propTypes.string.isRequired,
    message: propTypes.string,
    required: propTypes.bool.isRequired,
    class: propTypes.string
  }).isRequired,
  onChange: propTypes.func.isRequired,
  isSubmitted: propTypes.bool.isRequired,
  children: propTypes.oneOfType([propTypes.node, propTypes.string])
}

Password.defaultProps = {
  children: ""
}

export default Password
